import React, { useEffect, useState } from 'react';

import useInitMontage from 'ugc/hooks/useInitData/useInitMontage';
import WrapperMontage from 'ugc/components/ugcGallery/montage/WrapperMontage';
import WrapperSquare from 'ugc/components/ugcGallery/square/WrapperSquare';
import WrapperSliderShow from 'ugc/components/ugcGallery/sliderShow/WrapperSliderShow';
import WrapperMarquee from 'ugc/components/ugcGallery/marquee/WrapperMarquee';
import WrapperCollage from 'ugc/components/ugcGallery/collage/WrapperCollage';

import {
    ImageShowTypeMapping,
    galleryGameSetting as defaultGalleryGameSetting
} from 'editor/components/Gallery/SettingPreviews/defaultGameSetting';

export default function OuterLayerGallery({ promoUUID: queryPromoUUID }) {
    const initData = useInitMontage(queryPromoUUID);
    const [type, setType] = useState('');
    const [data, setData] = useState(initData);

    useEffect(() => {
        if (Boolean(initData)) {
            setData(initData);
            const {
                settingGame: { galleryGameSetting }
            } = initData;
            if (galleryGameSetting === undefined) {
                const newData = {
                    ...initData,
                    settingGame: {
                        ...initData.settingGame,
                        galleryGameSetting: defaultGalleryGameSetting
                    }
                };
                setData(newData);
                return setType(ImageShowTypeMapping.SQUARE);
            }
            const {
                versionStyleSettings: { imgShowType }
            } = galleryGameSetting;
            setType(imgShowType);
        }
    }, [initData]);

    const Container = type => {
        switch (true) {
            case type === ImageShowTypeMapping.SQUARE:
                return <WrapperSquare data={data} />;
            case type === ImageShowTypeMapping.WATERFALL:
                return <WrapperMontage data={data} />;
            case type === ImageShowTypeMapping.SLIDERSHOW:
                return <WrapperSliderShow data={data} />;
            case type === ImageShowTypeMapping.MARQUEE:
                return <WrapperMarquee data={data} />;
            case type === ImageShowTypeMapping.COLLAGE:
                return <WrapperCollage data={data} />;
            default:
                return {};
        }
    };

    return Boolean(type) && Container(type);
}
